import React, { useEffect, useState } from "react";

import { Formik, Form } from "formik";

import providerManagerEntitiesApi from "apis/providerManagerEntity";
import { Button, PageLoader, Pane, Typography } from "clearsense-ui/components";
import { Input } from "clearsense-ui/components/formik";

import { ADD_ENTITY_VALIDATION } from "./validations";

const CreateEntity = ({
  isCreateEntity,
  setIsCreateEntity,
  editEntityId,
  setEditEntityId,
}) => {
  const [entity, setEntity] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const handelPaneClose = () => {
    setEditEntityId();
    setIsCreateEntity(false);
  };

  const handleSave = async ({ name, entity_key_name }) => {
    const payload = {
      name: name.trim(),
      entity_key_name: entity_key_name.trim(),
    };

    try {
      editEntityId
        ? await providerManagerEntitiesApi.update(entity.id, payload)
        : await providerManagerEntitiesApi.create(payload);
      handelPaneClose();
    } catch (error) {
      logger.error(error);
    }
  };

  const fetchEntity = async id => {
    try {
      setIsLoading(true);
      const { data } = await providerManagerEntitiesApi.show(id);
      setEntity(data);
    } catch (error) {
      logger.info(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => editEntityId && fetchEntity(editEntityId), [editEntityId]);

  return (
    <Formik
      initialValues={editEntityId ? entity : { name: "", entity_key_name: "" }}
      validationSchema={ADD_ENTITY_VALIDATION}
      onSubmit={handleSave}
    >
      {({ submitForm, resetForm }) => (
        <Form noValidate className="w-full">
          <Pane isOpen={isCreateEntity} onClose={handelPaneClose}>
            <Pane.Header>
              <Typography style="h3" type="semibold" className="-mt-3">
                {editEntityId ? "Edit" : "Create"} Entity
              </Typography>
            </Pane.Header>
            {isLoading ? (
              <PageLoader />
            ) : (
              <>
                <Pane.Body className="space-y-4">
                  <Input
                    required
                    name="name"
                    label="Entity Name"
                    placeholder="Enter Entity name"
                    className="w-full flex-grow-0"
                  />
                  <Input
                    required
                    name="entity_key_name"
                    label="Entity Key Name"
                    placeholder="Enter Entity Key name"
                    className="w-full flex-grow-0"
                  />
                </Pane.Body>
                <Pane.Footer className="space-x-4">
                  <Button label="Save" type="submit" onClick={submitForm} />
                  <Button
                    label="Cancel"
                    style="secondary"
                    onClick={() => {
                      handelPaneClose();
                      resetForm();
                    }}
                  />
                </Pane.Footer>
              </>
            )}
          </Pane>
        </Form>
      )}
    </Formik>
  );
};

export default CreateEntity;
